import boletaApi from "./boletaApi";

export const loginAffiliateAuthentication = async (CUIL) => {
  try {
    return await boletaApi.post("/loginafiliado", { cuil: CUIL });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
